module.exports = __webpack_public_path__ + "img/user02.981ff8c5.jpg";